import { css } from "@emotion/react";

export const text = css`
  text-align: center;
  padding: 1rem 0;
`;
